import { Box, Chip } from "@mui/material";
import { V2_COLORS } from "@/pages/InvoiceManagement/v2/constants/colors";
import type { RfqBucket } from "../types";
import { RFQ_BUCKETS } from "../constants/buckets";

interface RfqBucketChipsProps {
  counts: Partial<Record<RfqBucket, number>>;
  selected: RfqBucket;
  onSelect: (bucket: RfqBucket) => void;
}

export default function RfqBucketChips({ counts, selected, onSelect }: RfqBucketChipsProps) {
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        backgroundColor: "#fff",
        borderBottom: `1px solid ${V2_COLORS.border}`,
        display: "flex",
        gap: 1,
        overflowX: "auto",
        py: 1,
        px: 2,
        WebkitOverflowScrolling: "touch",
        "&::-webkit-scrollbar": { display: "none" },
        scrollbarWidth: "none",
      }}
    >
      {RFQ_BUCKETS.map((bucket) => {
        const active = bucket.key === selected;
        return (
          <Chip
            key={bucket.key}
            label={`${bucket.label} (${counts[bucket.key] ?? 0})`}
            variant={active ? "filled" : "outlined"}
            color={active ? "primary" : "default"}
            onClick={() => onSelect(bucket.key)}
            sx={{ flexShrink: 0 }}
          />
        );
      })}
    </Box>
  );
}
